import { IPendoConfiguration } from '../domain/pendo.entity';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IUserPendoInfo } from '../domain/user-pendoInfo.entity';
@Injectable({
  providedIn: 'root',
})
export class PendoConfigurationService {
  configurationApiUrl = environment.apiBaseUrl + 'configuration/';
  pendoApiUrl = environment.apiBaseUrl + 'pendo/';

  constructor(private httpClient: HttpClient) {
  }

  getPendoConfiguration(): Observable<IConfiguration> {
    return this.httpClient.get<IConfiguration>(this.configurationApiUrl);
  }

  getUserPendoInfo(): Observable<IUserPendoInfo> {
    return this.httpClient.get<IUserPendoInfo>(this.pendoApiUrl + 'userinfo');
  }

}


interface IConfiguration {
  enableSpecialPricingDiscountFormulas: boolean;
  enableCollisionDiscounts: boolean;
  enableMechSupplierAccess: boolean;
  enableQuickCalculator: boolean;
  traxPartnersPendoEnabled: boolean;
  pendoApiKey: string;
}
